import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Clock from './Clock'

import styles from './StatusIndicator.module.scss'

const StatusIndicator = ({ text, icon, available, className, showClock, ...props }) => {
  const currentStatus = available ? 'available' : 'unavailable'
  const classNames = cn(styles.statusIndicator, styles[currentStatus], className)

  const [isMobileScreen, setIsMobileScreen] = useState(false)

  function updateIsMobileScreen(e) {
    setIsMobileScreen(e.matches)
  }

  useEffect(() => {
    const mediaWatcher = window.matchMedia("screen and (min-width: 500px")
    setIsMobileScreen(mediaWatcher.matches)

    
    mediaWatcher.addEventListener('change', updateIsMobileScreen)

    return function cleanup() {
      mediaWatcher.removeEventListener('change', updateIsMobileScreen)
    }
  }, [])

  if (isMobileScreen) {
    return (
      <div {...props} className={classNames}>
        {icon}
        <span className={styles.text} style={{color: text === "Offline" ? "#EF5350" : text === "Weak" ? "#FFF9C4" : "white"}}>
          {text}
        </span>
  
        <span style={{color: text === "Offline" ? "#EF5350" : text === "Weak" ? "#FFF9C4" : "white"}}>
          {showClock && (<Clock className={styles.clock} />)}
        </span>
      </div>
    )
  } else {
    return (
      <div {...props} className={classNames}>
        {icon}
      </div>
    )
  }

  
}

StatusIndicator.defaultProps = {
  text: '',
	icon: null,
	available: false,
}

StatusIndicator.propTypes = {
  text: PropTypes.string,
	icon: PropTypes.element,
	available: PropTypes.bool,
}

export default StatusIndicator
